export const errors = {
  booking_expired: {
    msg: `That took a little too long. Please refresh to get our latest menu and availabilities.`,
    clear: false,
  },
  ig_nonexistent_user: {
    msg: `We can't seem to find you on Instagram. Please double-check your handle, or DM us for help.`,
    clear: "onBlur",
  },
  ig_private_user: {
    msg: `It looks like your Instagram privacy settings are preventing us from reaching you. Please DM us then try again.`,
    clear: "onBlur",
  },
  incomplete_order: {
    msg: `Looks like you haven't ordered enough doughnuts to meet our minimum order. You can find our requirements below the menu.`,
    clear: "onBlur",
  },
  incomplete_recipient: {
    msg: `Looks like you haven't filled out some of the required recipient fields. Missing or invalid fields are shown in red.`,
    clear: "onBlur",
  },
  invalid_credentials: {
    msg: `There's an issue with your account. Please refresh to reset it.`,
    clear: false,
  },
  invalid_params: {
    msg: `We're having trouble processing some of your input. Please review it and try again.`,
    clear: "onBlur",
  },
  internal_error: {
    msg: `We're having some trouble processing your order. Please try submitting it one more time.`,
    clear: "onBlur",
  },
  internal_error_2: {
    msg: `We're having some computer troubles. Please try again later.`,
    clear: false,
  },
  lalamove_quote_expired: {
    msg: `Our delivery partner has updated its rates. Please reselect your address to view your new delivery fee.`,
    clear: "onBlur",
  },
  menu_changed: {
    msg: `It looks like some of your selections are no longer available. Please refresh to get our latest menu and availabilities.`,
    clear: false,
  },
  no_network: {
    msg: `Network issue. Please refresh.`,
    clear: false,
  },
  no_omise: {
    msg: `We're having trouble reaching our payment processor. Please DM us to confirm your order.`,
    clear: false,
  },
  no_omise_internal: {
    msg: `We're having some trouble processing your order. Please DM us to confirm it.`,
    clear: false,
  },
  no_lalamove: {
    msg: `We're having trouble reaching our delivery partner. Please try selecting your address one more time.`,
    clear: "onBlur",
  },
  no_lalamove_internal: {
    msg: `We're having trouble reaching our delivery partner. Please try submitting your order one more time.`,
    clear: "onBlur",
  },
  otp_expired: {
    msg: `Your OTP has expired. Please refresh to try again.`,
    clear: false,
  },
  otp_incorrect: {
    msg: `The entered OTP is incorrect.`,
    clear: "onBlur",
  },
  otp_too_many_attempts: {
    msg: `You entered too many incorrect OTPs. Please wait a few minutes then refresh to try again.`,
    clear: false,
  },
  too_far: {
    msg: `The address you selected is outside of our delivery area. Please try a different address.`,
    clear: "onBlur",
  },
  payment_failed: {
    msg: `Your payment was declined. Please try again with a different card.`,
    clear: "onBlur",
  },
  too_many_bookings: {
    msg: `You have too many abandonned orders. Please try again later.`,
    clear: false,
  },
};
